import { Delete } from "@mui/icons-material";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { useState, useCallback } from "react";
import { useLoaderData } from "react-router-dom";

import EditUploadDocument from "../../../../components/modules/Documents/EditUploadDocument";
import DeleteDocumentModal from "../../../../components/modules/Documents/ViewDocuments/components/DeleteDocumentModal";
import PermissionWrapper from "../../../global/PermissionWrapper";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import { getExtension } from "../../../ui library/helpers/functions";
import HNSColors from "../../../ui library/HNSColors";
import { useViewDocumentsPermissions } from "../hooks/useViewDocumentsPermissions";

export default function TableActionsMenu({
  anchorEl,
  handleClose,
  selectedDoc,
  setSelectedDoc,
  onDocumentUpdate,
}) {
  const open = Boolean(anchorEl);
  const { documentsOpts } = useLoaderData();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { canChangeDocument, canDeleteDocument } = useViewDocumentsPermissions();

  function handleOpenEditModal() {
    setOpenEditModal(true);
    handleClose();
  }

  function handleOpenDeleteModal() {
    setOpenDeleteModal(true);
    handleClose();
  }

  const onCloseEditModal = useCallback(() => {
    setOpenEditModal(false);
    setSelectedDoc(null);
  }, []);

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              border: `1.9px solid ${HNSColors.secondary[600]}`,
              borderRadius: 2,
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              maxWidth: 120,
              "& .MuiMenuItem-root": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 3,
                px: 2,
              },
              "& .MuiMenuItem-root-MuiMenu-list": {
                paddingTop: 0,
                paddingBottom: 0,
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: HNSColors.tertiary[900],
              },
            },
          },
        }}
      >
        <PermissionWrapper permission={canChangeDocument}>
          <MenuItem onClick={handleOpenEditModal}>
            <ListItemText primary="Edit" />
            <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
              <Svg
                name={SvgEnum.HisEdit3}
                color={HNSColors.primary[500]}
                fontSize="small"
                sx={{
                  width: "1.25rem",
                }}
              />
            </ListItemIcon>
          </MenuItem>
        </PermissionWrapper>
        <PermissionWrapper permission={canDeleteDocument}>
          <MenuItem onClick={handleOpenDeleteModal}>
            <ListItemText primary="Delete" />
            <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
              <Delete fontSize="small" color="error" />
            </ListItemIcon>
          </MenuItem>
        </PermissionWrapper>
      </Menu>
      {openEditModal && (
        <EditUploadDocument
          open
          onClose={onCloseEditModal}
          selectedDocument={selectedDoc}
          externalRefresh={onDocumentUpdate}
        />
      )}
      <DeleteDocumentModal
        doc={selectedDoc}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        getExtension={getExtension}
        documentTypeObj={documentsOpts?.docTypeOptions}
        onDocumentUpdate={onDocumentUpdate}
      />
    </>
  );
}
